var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",style:({width: `${_vm.width}px`, height: `${_vm.height}px` }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.type}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }